export const BLOCK_TYPE_TEXT_WITH_IMAGE_SPLIT = 'textWithImageSplit';
